import GatewayService from '@/service/gateway-service';
import { SEPHORA_PRODUCTS } from '@/components/sephora-products/gql';
import {
  GoalsPositionEnum,
  PositionEnum
} from '@/components/sephora-products/constants';

/**
 * Product object.
 * @typedef {Object} Product
 * @property {string} id - The ID of the product.
 * @property {string} title - The title of the product.
 * @property {string} handle - The handle of the product.
 * @property {Object} featuredImage - The featured image of the product.
 * @property {string} featuredImage.url - The URL of the featured image of the product.
 */

export default class SephoraProductsUtils {
  /**
   * @type {Product[]} products - Array of products or an empty array.
   */
  static products = [];
  /**
   * @return {Promise<Array<Product>>}
   */
  static async getProducts() {
    if (SephoraProductsUtils.products.length !== 0)
      return SephoraProductsUtils.products;

    const response = await GatewayService.getStoreFront().getRequest({
      query: SEPHORA_PRODUCTS
    });

    const getHairType = (handle) => {
      const hairType = ['wavy', 'straight', 'curly', 'coily'].find((type) =>
        handle.includes(type)
      );

      return hairType;
    };

    const products =
      response?.collection?.products?.edges?.map((x) => ({
        ...x.node,
        position: PositionEnum[x.node.handle] ?? { desktop: 100, mobile: 100 },
        hairType: getHairType(x.node.handle),
        goalPosition: GoalsPositionEnum?.[x.node.handle] ?? 100
      })) ?? [];

    return products;
  }
}
